import React from "react";
import PropTypes from "prop-types";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import { observer, PropTypes as mbxPropTypes } from "mobx-react";
import _ from "lodash";

// Local modules
import MenuActions from "./MenuActions";
import EnableFeatureIcons from "./EnabledFeatureIcons";

const evalEmptyFields = [null, "0", "", 0];

const PlayerRow = observer(
  ({ classes, playerList, anchorEls, handleClick, handleClose }) => {
    return (
      <TableBody>
        {playerList.map((player, i) => {
          return (
            <TableRow
              key={`agent-list${player.IdPlayer}`}
              style={{ backgroundColor: i % 2 ? "#fff" : "#eee" }}
            >
              <TableCell className={classes.smallCell}>
                <MenuActions
                  {...{
                    classes: classes,
                    player: player,
                    idPlayer: player.IdPlayer,
                    anchorEls: anchorEls,
                    handleClick: handleClick,
                    handleClose: handleClose,
                  }}
                />
              </TableCell>
              <TableCell className={classes.smallCell}>
                {player.Player === "" ? "DEFAULT" : player.Player}
              </TableCell>
              <TableCell className={classes.smallCell}>
                {_.includes(evalEmptyFields, player.GlobalMaxPay)
                  ? "-"
                  : player.GlobalMaxPay}
              </TableCell>
              <TableCell className={classes.smallCell}>
                <EnableFeatureIcons
                  toEvaluate={
                    player.CWSlive === "True" || player.CWSlive === true
                  }
                />
              </TableCell>
              <TableCell className={classes.smallCell}>
                <EnableFeatureIcons
                  toEvaluate={
                    player.EZlive === "True" || player.EZlive === true
                  }
                />
              </TableCell>
              <TableCell className={classes.smallCell}>
                <EnableFeatureIcons
                  toEvaluate={
                    player.ReverseCountsDouble === "True" ||
                    player.ReverseCountsDouble === true
                  }
                />
              </TableCell>
              <TableCell className={classes.smallCell}>
                {_.includes(evalEmptyFields, player.ReverseLimit)
                  ? "-"
                  : player.ReverseLimit}
              </TableCell>
              <TableCell className={classes.smallCell}>
                {_.includes(evalEmptyFields, player.LiveCasinoWeeklyLimit)
                  ? "-"
                  : player.LiveCasinoWeeklyLimit}
              </TableCell>
              <TableCell className={classes.smallCell}>
                {player.UI_Version}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    );
  }
);

PlayerRow.propTypes = {
  classes: PropTypes.object.isRequired,
  playerList: mbxPropTypes.observableArrayOf(PropTypes.object),
};

export default PlayerRow;
